import { render, staticRenderFns } from "./KeywordsModal.vue?vue&type=template&id=59aaf89a&"
import script from "./KeywordsModal.vue?vue&type=script&lang=js&"
export * from "./KeywordsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports